<template>
  <div class="module">
    <p class="moduleTitle">{{title}}</p>
    <div class="moduleCard">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'moduleCard',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  }
}
</script>

<style scoped lang="less">
.module{
  margin-bottom: 60px;
  .moduleTitle{
    color: #020A29;
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .moduleCard{
    width: 100%;
    background: #fff;
    box-shadow:0 5px 14px 0 rgba(214,218,230,0.2);
    border-radius:6px;
    padding: 30px;
    box-sizing: border-box;
  }
}
</style>
